module.exports = "<div class=\"section\" *ngIf=\"events.length\">\r\n  <div *ngFor=\"let event of events\">\r\n    <h4 class=\"event-title\"><a href=\"\" [routerLink]=\"['/events', event.id]\">{{event.title}}</a></h4>\r\n    <p class=\"event-desc\">\r\n      <span class=\"event-short\">{{event.shortDesc}}</span>\r\n      <span class=\"date\">{{event.createdOn | date:'dd.MM.yyyy'}}</span>\r\n    </p>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/events/event-list/event-list.component.html
// module id = ./src/app/events/event-list/event-list.component.html
// module chunks = dashboard.module